import { ErrorPage } from "@/components/ui/ErrorPage";

export default function TestGiaCompletato() {
  return (
    <ErrorPage
      emoji="✅"
      titolo="Hai già completato questo test"
      messaggio="Puoi consultare i tuoi risultati nella tua area personale."
      cta={{ label: "Vedi i risultati", to: "/area" }}
    />
  );
}
